import PropTypes from 'prop-types';
import React from 'react';

import './statistics.scss';

const StatisticsCard = ({
	className,
	color = 'light',
	disclaimer,
	percentage,
	text,
}) => {
	const colors = {
		blue: 'bg-blue-500 text-white',
		cyan: 'bg-cyan-500 text-white',
		dark: 'bg-dark text-white',
		light: 'bg-light',
		primary: 'bg-primary text-white',
		primaryLight: 'bg-primary-light',
		red: 'bg-red-500 text-white',
		white: 'bg-white',
	};

	return (
		<>
			<div
				className={`${colors[color]} ${className} card statistics-card border-0 mb-3`}
			>
				<div className="card-body">
					<div className="statistics-card-percentage rounded-2 p-3 title-large text-number d-inline-block">
						{percentage}
						{'%'}
					</div>
					<p className="mb-5 pb-5 mt-2">{text}</p>
					<div
						aria-label="Example 1px high"
						aria-valuemax="100"
						aria-valuemin="0"
						aria-valuenow={percentage}
						className="progress"
						role="progressbar"
						style={{ height: '3px' }}
					>
						<div
							className="progress-bar"
							style={{ width: `${percentage}%` }}
						></div>
					</div>
					{disclaimer && <div className="xs mt-2">{disclaimer}</div>}
				</div>
			</div>
		</>
	);
};

StatisticsCard.propTypes = {
	className: PropTypes.string,
	color: PropTypes.string,
	disclaimer: PropTypes.string,
	percentage: PropTypes.number,
	text: PropTypes.string,
};

export default StatisticsCard;
